export const labelStyles = {
    label: {
        display: 'block',
        ['& > *']: {
            display: 'block',
            mb: '1em'
        }
    }
};
